import { useNodesData, Handle, Position } from "@xyflow/react";
import { usePipelineBuilder } from "V2.0/HomePages/Pipelines/PipelineBuilder/PipelineBuilderProvider";
import { AssistantNodeAction, NodeType } from "../Models/NodeType";
import { validateNodeConfig } from "../NodeConfigure/nodeValidation";
import {
  Node,
  NodeActions,
  NodeBadge,
  NodeBody,
  NodeHeader,
  NodeName,
  NodePorts,
} from "./Components/Node";
import AddStepAction from "./Components/AddStepAction";
import ConfigureStepAction from "./Components/ConfigureStepAction";
import DeleteStepAction from "./Components/DeleteStepAction";
import { NodeUIRegistry } from "../Models/nodeUIRegistry";
import {
  TAssistantNodeConfig,
  VoiceAssistantNodeResult,
} from "../Models/Assistant";
import NodeExecutionStatusBadge from "./Components/NodeExecutionStatus";
import useNodeExecution from "./Hooks/useNodeExecution";
import usePipelineNode from "./Hooks/usePipelineNode";

export default AssistantNode;

function AssistantNode(props) {
  const { id } = props;

  const {
    data,
    onDelete,
    handleAdd,
    isExecuted,
    internalNode,
    isPanelActive,
    isPreviewMode,
    onConfigureNode,
    executedNodeStatus,
  } = usePipelineNode<TAssistantNodeConfig>(id);

  const {
    label,
    color,
    icon: Icon,
  } = NodeUIRegistry[NodeType.ASSISTANT][data.action];

  const ports =
    data.action === AssistantNodeAction.VOICE_CALL
      ? Object.values(VoiceAssistantNodeResult)
      : ["default"];

  return (
    <>
      <Handle
        type="target"
        position={Position.Top}
      />
      <Node status={executedNodeStatus}>
        <NodeHeader>
          <NodeBadge
            color={color}
            label={label}
            icon={<Icon className="size-4" />}
          />
          <NodeActions hideActions={isPanelActive}>
            {!isPreviewMode && <AddStepAction onAddStep={handleAdd} />}
            {(!isPreviewMode || isExecuted) && (
              <ConfigureStepAction
                onConfigureStep={() => onConfigureNode(internalNode)}
              />
            )}
            {!isPreviewMode && (
              <DeleteStepAction onDeleteStep={() => onDelete(internalNode)} />
            )}
          </NodeActions>
        </NodeHeader>
        <NodeBody>
          <NodeName name={data.name} />
          {isExecuted && (
            <NodeExecutionStatusBadge status={executedNodeStatus} />
          )}
        </NodeBody>
      </Node>
      <NodePorts ports={ports} />
    </>
  );
}
